<div class="header-actions">
  <button mat-icon-button [matTooltip]="
    isUpdaterManager ? 
    ('admin.flavor-management.toggle-page.toggleToUpdates' | translate) : 
    ('admin.update-management.toggle-page.toggleToFlavors' | translate)" (click)="togglePage()">
    <mat-icon>swap_horiz</mat-icon>
  </button>
</div>

<div class="full-width" *ngIf="isUpdaterManager">
  <div class="create-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'admin.update-management.create.flavor' | translate }}</mat-label>
      <mat-select [ngModel]="selectedFlavor" (ngModelChange)="onFlavorChange($event)">
        <mat-option *ngFor="let flavor of flavors" [value]="flavor">
          {{ flavor.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'admin.update-management.create.priority' | translate }}</mat-label>
      <mat-select [(value)]="selectedPriority">
        <mat-option *ngFor="let p of priorities" [value]="p.value">
          {{ p.label | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="selectedPriority === UpdatePriorityEnum.Deadline" appearance="outline" class="full-width">
      <mat-label>{{ 'admin.update-management.create.deadline-date' | translate }}</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="deadline" [min]="minDeadlineDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="requiresFile" appearance="outline" class="full-width upload-field"
      (click)="fileInput.click()">
      <button mat-icon-button matPrefix (click)="fileInput.click(); $event.stopPropagation()" type="button">
        <mat-icon>upload</mat-icon>
      </button>
      <input matInput type="text" [value]="selectedFile?.name || ''"
        [placeholder]="'admin.update-management.create.file' | translate" readonly />
      <input #fileInput type="file" [accept]="acceptedExtensions" (change)="onFileSelected($event)" hidden />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'admin.update-management.create.version' | translate }}</mat-label>
      <input matInput [(ngModel)]="version" [readonly]="selectedFile != null">
    </mat-form-field>

    <mat-form-field *ngIf="requiresVersionCode" appearance="outline" class="full-width">
      <mat-label>{{ 'admin.update-management.create.version-code' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="versionCode">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width fixed-height-field">
      <mat-label>{{ 'admin.update-management.create.release-notes' | translate }}</mat-label>
      <textarea matInput class="fixed-textarea no-resize" [(ngModel)]="releaseNotes" maxlength="500" rows="1"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'admin.update-management.create.status' | translate }}</mat-label>
      <mat-select [(value)]="selectedStatus">
        <mat-option *ngFor="let s of statuses" [value]="s.value">
          {{ s.label | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-flat-button class="btn-yes-wizard" (click)="submitUpdate()">
      {{'admin.update-management.create.submit' | translate}}
    </button>
  </div>

  <div class="table-container" style="margin-top: 20px;">
    <table mat-table [dataSource]="pdvUpdates" class="mat-elevation-z8" style="width: 100%;">

      <ng-container matColumnDef="flavor">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.flavor' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.flavor }}</td>
      </ng-container>

      <ng-container matColumnDef="latestPdvVersion">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.version' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.latestPdvVersion }}</td>
      </ng-container>

      <ng-container matColumnDef="versionCode">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.version-code' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ formatValue(element.versionCode) }}</td>
      </ng-container>

      <ng-container matColumnDef="downloadUrl">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.download' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <a *ngIf="element.downloadUrl" [href]="element.downloadUrl" target="_blank"
            matTooltip="{{ element.downloadUrl }}" class="download-link"> {{ element.downloadUrl }} </a>
          <span *ngIf="!element.downloadUrl">—</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="updatePriority">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.priority' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ getPriorityLabel(element.updatePriority) | translate }}</td>
      </ng-container>

      <ng-container matColumnDef="deadline">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.deadline' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.deadline | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="releaseNotes">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.notes' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.releaseNotes" class="ellipsis" matTooltip="{{ element.releaseNotes }}"> {{
            element.releaseNotes }} </span>
          <span *ngIf="!element.releaseNotes">—</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="updateInstructions">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.instructions' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.updateInstructions" class="ellipsis" matTooltip="{{ element.updateInstructions }}"> {{
            element.updateInstructions }} </span>
          <span *ngIf="!element.updateInstructions">—</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="updateStatus">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.status' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ getStatusLabel(element.updateStatus) | translate }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>{{ 'admin.update-management.column.created-at' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="deactivateUpdate(element)"
            [matTooltip]="'admin.update-management.tooltips.deactivate' | translate">
            <mat-icon>block</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          {{ 'admin.update-management.none-found' | translate }}
        </td>
      </tr>
    </table>
  </div>
</div>
<app-flavors-management *ngIf="!isUpdaterManager"></app-flavors-management>